export const bodyStyleData = [
  { id: 1, name: "Bike" },
  { id: 2, name: "4*4" },
  { id: 3, name: "Cabrio" },
  { id: 4, name: "Convertable" },
  { id: 5, name: "Double Cab" },
];

export const makeData = [
  { id: 1, name: "Make", amount: 1 },
  { id: 2, name: "Alpha Romeo", amount: 46 },
  { id: 3, name: "Audi", amount: 496 },
  { id: 4, name: "BAW", amount: 425 },
  { id: 5, name: "BMW", amount: 21 },
];

export const fuelTypeData = [
  { id: 1, name: "Petrol" },
  { id: 2, name: "Diesel" },
  { id: 3, name: "Hybrid" },
  { id: 4, name: "Electric" },
  { id: 5, name: "LPG (Gas)" },
];

export const listingTypeData = [
  { id: 1, name: "On Auction", amount: 11765 },
  { id: 2, name: "Buy Now", amount: 30492 },
  { id: 3, name: "Make an Offer", amount: 8620 },
  { id: 4, name: "Auction and Buy Now", amount: 1434 },
  { id: 5, name: "Classified Ad", amount: 298 },
];

export const doorsData = [
  { id: 1, name: "2 Doors" },
  { id: 2, name: "3 Doors" },
  { id: 3, name: "4 Doors" },
  { id: 4, name: "5 Doors" },
  { id: 5, name: "6 Doors" },
];

export const transmissionData = [
  { id: 1, name: "Manual" },
  { id: 2, name: "Automatic" },
  { id: 3, name: "Semi-Automatic" },
  { id: 4, name: "CVT" },
  { id: 5, name: "Tiptronic" },
];

export const colorData = [
  { id: 1, name: "Black" },
  { id: 2, name: "Blue" },
  { id: 3, name: "Brown" },
  { id: 4, name: "Gold" },
  { id: 5, name: "Green" },
];

export const conditionData = [
  { id: 1, name: "New" },
  { id: 2, name: "Used" },
  { id: 3, name: "Demo" },
  { id: 4, name: "Reconditioned" },
  { id: 5, name: "Refurbished" },
];

export const sellerTypeData = [
  { id: 1, name: "Dealer" },
  { id: 2, name: "Private" },
  { id: 3, name: "Trade" },
  { id: 4, name: "Other" },
];

export const searchData = [{ id: 1, name: "Search" }];
